import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-24 bg-[#F9F7F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="w-full h-[480px]">
            <img
              src="https://public.readdy.ai/ai/img_res/7a7209b929f3f6d7c376787fc088fdad.jpg"
              alt="ARAVELLA outdoor living"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-end pb-16 px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Your Dream Outdoor Space<br />
              <em className="not-italic text-[#A8D080]">Starts Here</em>
            </h2>
            <p className="text-white/70 text-base mb-8 max-w-md">
              Free shipping on orders over $500. 5-year warranty on all teak products.
            </p>
            <Link
              to="/products"
              className="bg-white text-[#2D5016] font-bold px-10 py-4 rounded-full hover:bg-[#A8D080] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm tracking-wide"
            >
              Shop All Products
            </Link>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {[
            { icon: "ri-truck-line", title: "Free Shipping", desc: "On orders over $500" },
            { icon: "ri-shield-check-line", title: "5-Year Warranty", desc: "On all teak products" },
            { icon: "ri-refresh-line", title: "Easy Returns", desc: "30-day return policy" },
            { icon: "ri-customer-service-2-line", title: "Expert Support", desc: "Mon-Fri 9am-6pm MST" },
          ].map(badge => (
            <div key={badge.title} className="flex items-start gap-4 bg-white rounded-xl p-5">
              <div className="w-10 h-10 flex items-center justify-center bg-[#EEF5E8] rounded-lg flex-shrink-0">
                <i className={`${badge.icon} text-[#2D5016] text-lg`}></i>
              </div>
              <div>
                <div className="font-semibold text-[#1a1a1a] text-sm">{badge.title}</div>
                <div className="text-gray-400 text-xs mt-0.5">{badge.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
